<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <img src="./assets/images/robot.gif"  >
    </div>
</div>
